<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<div class="wassersport-wetter-container">
  <h3>Wassersportwetter Werte ({{wassersportWetter?.update}})</h3>

  <mat-card *ngFor="let wert of wassersportWetter.werte" class="wassersportwetter-werte-mat-card">
    <mat-card-title>{{wert.gebiet}}</mat-card-title>
    <mat-card-subtitle>{{wert.sonne}}</mat-card-subtitle>
    <mat-card-content class="wassersportwetter-werte-mat-card-content" *ngFor="let prognose of wert.prognose">
      <span class="wassersportwetter-werte-prognose-tageszeit"><b>{{prognose.tageszeit}}</b></span>
      <table class="wassersport-wetter-werte-table">
        <thead>
        <tr>
          <td>Temperatur</td>
          <td>Windboeen</td>
          <td>Windmittel</td>
          <td>Windrichtung</td>
        </tr>
        </thead>
        <tbody>
        <td>{{prognose?.temperatur.messwert + " " + prognose?.temperatur?.einheit}}</td>
        <td>{{prognose?.windboen?.messwert + " " + prognose?.windboen?.einheit}}</td>
        <td>{{prognose?.windmittel?.messwert + " " + prognose?.windmittel?.einheit}}</td>
        <td>{{prognose?.windrichtung?.messwert}}</td>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
  <h3>Wassertemperaturen</h3>
  <mat-card *ngFor="let wasserTemperatur of wassersportWetter.wasserTemperaturen"
            class="wassersportwetter-werte-mat-card" style="width: 96%">
    <mat-card-title>{{wasserTemperatur.gebiet}}</mat-card-title>
    <mat-card-content style="display:inline-block;margin: 15px" class="wassersportwetter-werte-mat-card-content"
                      *ngFor="let wertMitOrt of wasserTemperatur.werte">
      <span class="wassersportwetter-werte-prognose-tageszeit"><b>{{wertMitOrt.ort}}</b></span>
      <p>{{wertMitOrt?.temperatur?.messwert + " " + wertMitOrt?.temperatur?.einheit}}</p>
    </mat-card-content>
  </mat-card>
</div>
